import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../services/apiClient";

export default function AuctionSubscriptionGate({ children }: { children: JSX.Element }) {
  const [status, setStatus] = useState<"loading" | "allowed" | "upgrade" | "error">("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setStatus("loading");
    apiClient.get("/live-auctions/access").then(({ data }) => {
      if (active) setStatus(data.allowed === true ? "allowed" : "error");
    }).catch((error) => {
      if (active) setStatus(error.response?.data?.code === "AUCTION_SUBSCRIPTION_REQUIRED" ? "upgrade" : "error");
    });
    return () => { active = false; };
  }, [attempt]);

  if (status === "allowed") return children;
  return <section className="mx-auto max-w-xl px-6 py-32 text-center" aria-live="polite">
    <h1 className="text-2xl font-bold">TikTok Live Auctions</h1>
    {status === "loading" ? <p className="mt-4">Checking subscription…</p> : status === "upgrade" ? <>
      <p className="my-6">A paid subscription is required to manage TikTok auctions, buyers, wins, and packages.</p>
      <Link className="rounded-lg bg-blue-600 px-5 py-3 text-white" to="/pricing">View plans</Link>
    </> : <p className="my-6">Unable to verify your subscription. Please try again.</p>}
    {status !== "loading" && <button className="mt-6 block w-full text-blue-700" onClick={() => setAttempt(value => value + 1)}>
      Check again
    </button>}
  </section>;
}
